import { useTheme, type SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import { useMemo } from "react";

interface DrawerHtmlWrapperProps {
  html: string;
}

export function DrawerHtmlWrapper({ html }: Readonly<DrawerHtmlWrapperProps>): JSX.Element {
  const theme = useTheme();

  const innerHtmlStyles: SxProps = useMemo(
    function memoizeStyles() {
      const baseTextStyles = {
        fontSize: "16px",
        lineHeight: "21px",
        letterSpacing: "0.15px",
        fontFeatureSettings: "liga off, clig off",
        fontStyle: "normal",
        fontWeight: 400,
        fontFamily: "DM Sans",
        color: theme.palette.text.primary,
        whiteSpace: "pre-line",
      };

      const styles: SxProps = {
        ...baseTextStyles,
        "& *": {
          ...baseTextStyles,
        },
        "& strong, & b, & strong *, & b *": {
          fontWeight: 700,
        },
      };
      return styles;
    },
    [theme]
  );

  return <Box sx={innerHtmlStyles} dangerouslySetInnerHTML={{ __html: html }} />;
}
